import React from 'react';
import {StyleSheet, View, Platform} from 'react-native';

import {appBackgroundWhiteBG} from '../../utils/utils';
import LoginHeader from '../login/LoginHeader';
import LogoutCard from './LogoutCard';
import {CopyRightForTab} from '../../utils/CopyRightForTab';
import {useSelector} from 'react-redux';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {CopyRight} from '../../utils/CopyRight';

const LogoutScreen = () => {
   const isLandscapeMode = useSelector(selectScreenOrientation);
   var marginSpace = 20;
   const bottomTabHeight = 64;

   return (
      <View
         style={{flex: 1}}
         behavior={Platform.OS === 'ios' ? 'padding' : 'height'}>
         <View style={{flex: 1, backgroundColor: appBackgroundWhiteBG}}>
            <View
               style={{
                  flex: 1,
                  ...Platform.select({
                     web: {
                        flex: null,
                        height: '100vh',
                     },
                  }),
               }}>
               <View
                  style={{
                     flex: 1,
                     flexDirection: !isLandscapeMode ? 'column' : 'row-reverse',
                  }}>
                  <View style={{flex: isLandscapeMode ? 1 : 5}}>
                     <View
                        style={{
                           flex: isLandscapeMode ? 1 : 5,
                           marginTop: !isLandscapeMode ? 0 : marginSpace,
                           marginRight: !isLandscapeMode ? 0 : marginSpace,
                           marginBottom: !isLandscapeMode
                              ? 0
                              : marginSpace + bottomTabHeight,
                        }}>
                        <LoginHeader isLandscapeMode={isLandscapeMode} />
                     </View>
                  </View>
                  <View
                     style={{
                        flex: isLandscapeMode ? 1 : 16,
                        justifyContent: 'flex-start',
                     }}>
                     {!isLandscapeMode ? (
                        <LogoutCard />
                     ) : (
                        <View
                           style={{
                              flex: 1,
                              justifyContent: 'center',
                           }}>
                           <LogoutCard />
                        </View>
                     )}
                  </View>
               </View>
               {isLandscapeMode ? (
                  <CopyRightForTab
                     isPortrait={!isLandscapeMode}
                     isCopyrightShown={true}
                  />
               ) : (
                  <View style={{bottom: 5}}>
                     <CopyRight
                        screenOrientation={isLandscapeMode}
                        isCopyrightShown={true}
                     />
                  </View>
               )}
            </View>
         </View>
      </View>
   );
};

const styles = StyleSheet.create({
   sectionContainer: {
      marginTop: 32,
      paddingHorizontal: 24,
   },
   sectionTitle: {
      fontSize: 24,
      fontWeight:
         Platform.OS === 'ios' || Platform.OS === 'macos' ? '600' : 600,
   },
   sectionDescription: {
      marginTop: 8,
      fontSize: 18,
      fontWeight:
         Platform.OS === 'ios' || Platform.OS === 'macos' ? '400' : 400,
   },
   highlight: {
      fontWeight:
         Platform.OS === 'ios' || Platform.OS === 'macos' ? '700' : 700,
   },
});

export default LogoutScreen;
